import { CartSlideInConfig } from '../types.js';
import { buildConfig, type BuildConfig } from '../config/buildConfig.js';
import { getAuthInfo } from '../services/authService.js';

export function getEnvConfig(): BuildConfig {
  const defaultEnv = 'dev' as const;
  const envKey =
    process.env.ENV && process.env.ENV in buildConfig
      ? (process.env.ENV as keyof typeof buildConfig)
      : defaultEnv;
  return buildConfig[envKey];
}

export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export async function fetchUserInfo() {
  const userInfo = await getAuthInfo();
  return { Noodle: generateUUID(), ...userInfo };
}

export function goToCart(
  discoveryConfig: BuildConfig,
  config: CartSlideInConfig,
) {
  if (config.navigateToCart) {
    config.navigateToCart();
    return;
  }
  window.location.href = `${discoveryConfig.shopping ?? ''}/cart/shoppingcart`;
}
